export default "__VITE_ASSET__Bz747hE7__"